import { RiskMatrixAction, RiskMatrixEvent } from './risk-matrix.component';

export interface BulkRiskMatrixPayload {
  entityId: string;
  events: BulkRiskMatrixEventDto[];
}

export interface BulkRiskMatrixEventDto {
  id?: string;
  evento_rischio_id?: string;
  _isNew?: boolean;
  nome: string;
  descrizione: string;
  gravita: number;
  tipologia?: string;
  pericolo_chimico?: boolean;
  pericolo_fisico?: boolean;
  pericolo_biologico?: boolean;
  pericolo_quantitativo?: boolean;
  attivo: boolean;
  lavorato: boolean;
  probabilita?: number | null;
  mitigationActions: BulkRiskMatrixActionDto[];
}

export interface BulkRiskMatrixActionDto {
  id?: string;
  azione_mitigatrice_id?: string;
  _isNew?: boolean;
  nome: string;
  descrizione: string;
  stato: number;
  riduzione_probabilita?: number | null;
  responsabile?: string | null;
  pianificazione?: string | null;
  avanzamento?: number | null;
  costi?: number | null;
  validazione?: string | null;
  tipologia_di_monitoraggio?: string | null;
  parametro_monitorato?: string | null;
}

export function mapEventsToBulkDto(entityId: string, events: RiskMatrixEvent[]): BulkRiskMatrixPayload {
  return {
    entityId,
    events: events.map(mapEventToBulkDto)
  };
}

function mapEventToBulkDto(event: RiskMatrixEvent): BulkRiskMatrixEventDto {
  return {
    id: event.id,
    evento_rischio_id: event.evento_rischio_id,
    _isNew: event._isNew,
    nome: event.evento.nome,
    descrizione: event.evento.descrizione,
    gravita: event.evento.gravita,
    tipologia: event.evento.tipologia,
    pericolo_chimico: event.evento.pericolo_chimico,
    pericolo_fisico: event.evento.pericolo_fisico,
    pericolo_biologico: event.evento.pericolo_biologico,
    pericolo_quantitativo: event.evento.pericolo_quantitativo,
    attivo: event.attivo,
    lavorato: event.lavorato,
    probabilita: event.probabilita,
    mitigationActions: (event.actions ?? []).map(mapActionToBulkDto)
  };
}

function mapActionToBulkDto(action: RiskMatrixAction): BulkRiskMatrixActionDto {
  return {
    id: action.id,
    azione_mitigatrice_id: action.azione_mitigatrice_id,
    _isNew: action._isNew,
    nome: action.azione.nome,
    descrizione: action.azione.descrizione,
    stato: action.stato,
    riduzione_probabilita: action.riduzione_probabilita,
    responsabile: action.responsabile,
    pianificazione: action.pianificazione,
    avanzamento: action.avanzamento,
    costi: action.costi,
    validazione: action.validazione,
    tipologia_di_monitoraggio: action.tipologia_di_monitoraggio,
    parametro_monitorato: action.parametro_monitorato
  };
}
